<template>
    <div class="app">
        <AppHeader fixed>
            <SidebarToggler class="d-lg-none" display="md" mobile/>
            <router-link :to="{name: 'dashboard'}" class="navbar-brand" tag="b-link">
                <img class="logo" src="img/logo.png" alt="logo">
            </router-link>
            <SidebarToggler class="d-md-down-none" display="lg"/>
            <b-navbar-nav class="d-md-down-none pl-4"></b-navbar-nav>
            <b-navbar-nav class="ml-auto">
                <b-nav-item class="d-md-down-none">
                    <DefaultHeaderDropdownNotif/>
                </b-nav-item>
                <b-nav-item class="d-md-down-none">
<!--                    <DefaultHeaderDropdownTasks/>-->
                    <router-link :to="{ path: '/admin/schedule/list' }">
                        <i class="icon-calendar"></i>
                    </router-link>
                </b-nav-item>
                <DefaultHeaderDropdownAccnt/>
            </b-navbar-nav>
            <!--<AsideToggler class="d-none d-lg-block" />-->
            <!--<AsideToggler class="d-lg-none" mobile />-->
        </AppHeader>
        <div class="app-body">
            <AppSidebar fixed>
                <SidebarHeader/>
                <SidebarForm/>
                <SidebarNav :navItems="navigationItems"></SidebarNav>
                <SidebarFooter/>
                <SidebarMinimizer/>
            </AppSidebar>
            <main class="main">
                <nav class="breadcrumb bg-primary" :menu="links" v-if="links">
                    <div>
                        <template v-for="link in links" v-if="links.length > 0">
                            <template v-if="link.emit">
                                <button v-if="mixinCheckPermissions(link.permissions)" class="btn btn-light btn-md mr-2" href="#" @click="emit(link.emit)">
                                    <i :class="link.brand" class="mr-2 text-primary"></i>
                                    <span class="text-primary">{{link.name}}</span>
                                </button>
                            </template>
                            <template v-else>
                                <router-link v-if="mixinCheckPermissions(link.permissions)" class="btn btn-light btn-md mr-2" :to="{ path: link.path }">
                                    <i :class="link.brand" class="mr-2 text-primary"></i>
                                    <span class="text-primary">{{link.name}}</span>
                                </router-link>
                            </template>
                        </template>
                    </div>
                    <div>
                        <div v-if="loading.active" class="loading">
                            <loading size="medium"></loading>
                        </div>
                    </div>
                </nav>
                <div class="container-fluid router-view-container">
                    <router-view></router-view>
                </div>
            </main>
            <AppAside fixed>
                <!--aside-->
                <DefaultAside/>
            </AppAside>
        </div>
        <TheFooter>
            <!--footer-->
            <div>
                <span class="ml-1">ATA - Federación Nacional de Trabajadores Autónomos</span>
            </div>
            <div class="ml-auto">
                <span class="mr-1">Powered by</span>
                <a href="https://healios.tech">Healios Tech</a>
            </div>
        </TheFooter>
    </div>
</template>

<script>
    import nav from '@/_nav';
    import {
        Header as AppHeader,
        SidebarToggler,
        Sidebar as AppSidebar,
        SidebarFooter,
        SidebarForm,
        SidebarHeader,
        SidebarMinimizer,
        SidebarNav,
        Aside as AppAside,
        AsideToggler,
        Footer as TheFooter,
        Breadcrumb
    } from '@coreui/vue';
    import DefaultAside from './DefaultAside';
    import DefaultHeaderDropdown from './DefaultHeaderDropdown';
    import DefaultHeaderDropdownNotif from './DefaultHeaderDropdownNotif';
    import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt';
    import DefaultHeaderDropdownMssgs from './DefaultHeaderDropdownMssgs';
    import DefaultHeaderDropdownTasks from './DefaultHeaderDropdownTasks';
    import {mapState, mapGetters, mapActions} from 'vuex';

    export default {
        name: 'DefaultContainer',
        components: {
            AsideToggler,
            AppHeader,
            AppSidebar,
            AppAside,
            TheFooter,
            Breadcrumb,
            DefaultAside,
            DefaultHeaderDropdown,
            DefaultHeaderDropdownMssgs,
            DefaultHeaderDropdownNotif,
            DefaultHeaderDropdownTasks,
            DefaultHeaderDropdownAccnt,
            SidebarForm,
            SidebarFooter,
            SidebarToggler,
            SidebarHeader,
            SidebarNav,
            SidebarMinimizer
        },
        data() {
            return {
                navigationItems: null,
                links: []
            }
        },
        methods: {
            ...mapGetters([
                'authUser',
            ]),
            ...mapActions([
                'setAuthUser',
            ]),

            emit(listener) {
                this.$eventHub.$emit(listener, new Date());
            },

            mountNavMenu() {
                // Filtrado de opciones de menu lateral segun permisos
                // El padre se renderiza si se renderiza algún hijo
                // Los hijos se renderizan si el usuario tiene el permiso adecuado
                let self = this;

                // Copiamos para no modificar los valores por defecto durante una misma sesión
                let defaultNavItems = JSON.parse(JSON.stringify(nav.items));
                this.navigationItems = defaultNavItems.filter(item => {

                    if (item.permission) {

                        if (self.mixinCheckPermission(item.permission)) {
                            if (item.children) {
                                item.children = self.filterChildren(item);
                                return item;
                            } else {
                                return true;
                            }
                        }

                        return false;

                    } else {

                        if (item.children) {

                            let children = self.filterChildren(item);

                            if (children.length > 0) {
                                item.children = children;
                                return item;
                            } else {
                                return false;
                            }

                        } else {
                            return true;
                        }
                    }
                });
            },

            filterChildren(item) {
                let self = this;
                return item.children.filter(child => {
                    if (self.mixinCheckPermission(child.permission)) {
                        if (child.children) {
                            child.children = self.filterChildren(child);
                            return child;
                        } else {
                            return true;
                        }
                    }
                    return false;
                })
            },
        },
        computed: {
            ...mapState([
                'loading'
            ]),
            name() {
                return this.$route.name;
            },
            list() {
                return this.$route.matched.filter((route) => route.name || route.meta.label);
            },
        },
        created() {
            let self = this;
            this.$eventHub.$on('captureMenu', obj => {
                self.links = obj;
            });

            this.mountNavMenu();
        },

        beforeDestroy() {
            this.$eventHub.$off('captureMenu');
        }
    }
</script>

<style scoped>
    .logo {
        height: 40px !important;
    }
</style>